// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React from 'react'
import { error, warning } from 'react-notification-system-redux'
import { push } from 'react-router-redux'
import { UNCAUGHT_ERROR } from 'errors'
import { fetchProtectionProjectByRcn } from 'helpers/api/protection'
import { loadingToggler } from 'redux/modules/loading'
import ProtectionProjectAnalysisFailedToInitialize from '../ProtectionProjectAnalysisFailedToInitialize'

/**
 * takes an RCN number, finds the (protection) project id that it corresponds to it<br>
 * send the user to that project's "Run Analysis" page<br>
 * and display the ProtectionProjectAnalysisFailedToInitialize notification
 * @param {string} rcnNumber
 * @returns {function(*): *}
 */
const handleCreatedProtectionProjectWithFailedAnalysisKickOff = rcnNumber => dispatch => (
  dispatch(loadingToggler(
    async () => {
      try {
        const { entity } = await fetchProtectionProjectByRcn(rcnNumber)
        const { projectId } = entity
        dispatch(push(`/project-management/${projectId}/interference-analysis/parameters`))

        const uid = `warning-protection-project-create-for-rcn-${rcnNumber}`

        dispatch(warning({
          uid,
          autoDismiss: 0,
          children: (
            <ProtectionProjectAnalysisFailedToInitialize
              rcnNumber={rcnNumber}
              uid={uid} />
          ),
        }))
      } catch (err) {
        console.warn(err)
        dispatch(error({
          title: 'Failed to fetch newly created Protection Project.',
          message: err.message || UNCAUGHT_ERROR,
          dismissible: false,
          autoDismiss: 0,
          action: {
            label: 'Try Again.',
            callback: () => dispatch(handleCreatedProtectionProjectWithFailedAnalysisKickOff(rcnNumber)),
          },
        }))
      }
    }
  ))
)

export default handleCreatedProtectionProjectWithFailedAnalysisKickOff
